module.exports = __webpack_public_path__ + "static/img/s17.f070dba4.png";